import { Campaign } from '@shared/types/mylounge';

/**
 * Checks if a campaign is starting today based on its start date
 * @param startsAt - Campaign start date in ISO string format
 * @returns true if the campaign starts today, false otherwise
 */
export const isCampaignStartingToday = (startsAt: string): boolean => {
    const todayDateString = new Date().toISOString().substring(0, 10);
    return startsAt.substring(0, 10) === todayDateString;
};

/**
 * Filters campaigns to only include those starting today
 * @param campaigns - Array of campaigns to filter
 * @returns Array of campaigns that start today
 */
export const filterCampaignsStartingToday = (campaigns: Campaign[]): Campaign[] =>
    campaigns.filter(campaign => isCampaignStartingToday(campaign.startsAt));
